import {Component, Input, OnInit} from '@angular/core';
import {from, Observable, throwError} from "rxjs";
import {catchError, filter, map, switchMap, tap} from "rxjs/operators";
import {IShopUser} from "../../../session/customer-models";
import {AuthUtil} from "../../../auth/auth-util";
import {Constants} from "../../../constants";
import {IAd} from "../../../landing/landing.models";
import {LoggerService} from "../../../common/logger.service";
import {LandingService} from "../../../landing/landing.service";
import {UserService} from "../../../common/user.service";
import {AnalyticsService} from "../../../analytics/analytics.service";
import {BaseComponent} from "../../../base.component";
import {LocaleUtil} from "../../../util/locale-util";

@Component({
    selector: 'landing-ad-hero-base',
    templateUrl: './landing-ad-hero-base.component.html',
    styleUrls: ['./landing-ad-hero-base.component.scss'],
    standalone: false
})
export class LandingAdHeroBaseComponent extends BaseComponent implements OnInit {

    @Input() titleText: string;
    @Input() messageText: string;

    baseAd: IAd;
    isNfr: boolean = false;
    viewSizeMobile = Constants.VIEWSIZE_MOBILE_MAX;
    heroAdDesktopUrl: string;
    heroAdMobileUrl: string;

    constructor(
        loggerService: LoggerService,
        private landingService: LandingService,
        private userService: UserService,
        private analyticsService: AnalyticsService,
    ) {
        super(userService, loggerService);
    }

    ngOnInit(): void {
        this.initAds().subscribe();
    }

    initAds(): Observable<any> {
        return from(this.userService.getShopUserPromise()).pipe(
            filter((user: IShopUser) => !AuthUtil.isNfr(user)),
            tap((user: IShopUser) => this.isNfr = AuthUtil.isNfr(user)),
            switchMap((user: IShopUser) => this.getAd(LocaleUtil.getTranslationLocale(user))),
            catchError((error: any) => throwError(error))
        );
    }

    getAd(usanaLocale: string): Observable<any> {
        return this.landingService.getLandingAd(usanaLocale, Constants.AD_LANDING_HERO).pipe(
            tap(baseAd => this.baseAd = baseAd[0]),
            tap(() => this.setHeroAdUrls()),
            map(() => [this.baseAd])
        );
    }

    setHeroAdUrls(): void {
        if (this.baseAd && this.baseAd.images) {
            this.heroAdDesktopUrl = this.baseAd.images.find(image => image.imageType == Constants.IMAGE_TYPE_DESKTOP)?.imagePath;
            this.heroAdMobileUrl = this.baseAd.images.find(image => image.imageType == Constants.IMAGE_TYPE_MOBILE)?.imagePath;
            this.analyticsService.adPromotionViewEvent([this.baseAd]);
        }
    }

    sendAdPromotionClick(ad: IAd) {
        this.analyticsService.adPromotionClickEvent(ad);
    }

}
